/**
Author - Venkatesh Pullaganti 😃
Git - https://github.com/venkatesh1146
**/

import {baseTheme} from './Theme';

export const partnerTheme = {
  ...baseTheme,
  name: 'partner',

  // Colors
  colors: {
    ...baseTheme.colors,
    brand: {
      primary: '#6725F4',
      secondary: '#F8F4FF',
      tertiary: '#8670CC',
    },
    text: {
      primary: '#1c1c1c',
      secondary: '#7E7E7E',
      disabled: '#AAAAAA',
    },
    background: {
      primary: '#FFFFFF',
      secondary: '#F8F2FF',
    },
    feedback: {
      error: '#FF4E4E',
      success: '#4FC16F',
      warning: '#FFA63E',
      successLight: '#D9F9E8',
    },
    gradient: {
      primary: 'linear-gradient(90deg, #6F2FF 0%, #FF6B8B 100%)',
    },
    accent: {
      seashell: '#FFF4EF',
      floralWhite: '#FFF8EA',
      honeydew: '#E9FFEF',
      redSnow: '#FFF4F4',
    },
    border: {
      default: '#E3E3E3',
    },
  },

  // Typography
  typography: {
    fontFamily: {
      primary: 'Lato, sans-serif',
    },
    fontWeight: {
      regular: 400,
      medium: 500,
      semiBold: 600,
      bold: 700,
    },
    // Simple rem values - automatically responsive via CSS root font-size
    fontSize: {
      xxs: '0.857rem', // Auto-scales: ~10.2px → 12px
      xs: '1rem', // Auto-scales: ~11.9px → 14px
      sm: '1.143rem', // Auto-scales: ~13.6px → 16px
      md: '1.286rem', // Auto-scales: ~15.3px → 18px
      lg: '1.429rem', // Auto-scales: ~17px → 20px
      xl: '1.714rem', // Auto-scales: ~20.4px → 24px
      xxl: '2.286rem', // Auto-scales: ~27.2px → 32px
      xxxl: '2.857rem', // Auto-scales: ~34px → 40px
    },
    lineHeight: {
      tight: 1.2,
      normal: 1.5,
      loose: 1.8,
    },
    styles: {
      display: {
        fontFamily: 'Lato, sans-serif',
        fontSize: '2.857rem', // Auto-scales: ~34px → 40px
        fontWeight: 700,
        lineHeight: 1.2,
      },
      heading: {
        1: {
          fontFamily: 'Lato, sans-serif',
          fontSize: '2.286rem', // Auto-scales: ~27.2px → 32px
          fontWeight: 700,
          lineHeight: 1.2,
        },
        2: {
          fontFamily: 'Lato, sans-serif',
          fontSize: '1.714rem', // Auto-scales: ~20.4px → 24px
          fontWeight: 600,
          lineHeight: 1.2,
        },
        3: {
          fontFamily: 'Lato, sans-serif',
          fontSize: '1.429rem', // Auto-scales: ~17px → 20px
          fontWeight: 600,
          lineHeight: 1.3,
        },
      },
      body: {
        large: {
          fontFamily: 'Lato, sans-serif',
          fontSize: '1.429rem', // Auto-scales: ~17px → 20px
          fontWeight: 400,
          lineHeight: 1.5,
        },
        largeSemibold: {
          fontFamily: 'Lato, sans-serif',
          fontSize: '1.429rem', // Auto-scales: ~17px → 20px
          fontWeight: 600,
          lineHeight: 1.5,
        },
        medium: {
          fontFamily: 'Lato, sans-serif',
          fontSize: '1.286rem', // Auto-scales: ~15.3px → 18px
          fontWeight: 400,
          lineHeight: 1.5,
        },
        regular: {
          fontFamily: 'Lato, sans-serif',
          fontSize: '1.143rem', // Auto-scales: ~13.6px → 16px
          fontWeight: 400,
          lineHeight: 1.5,
        },
        small: {
          fontFamily: 'Lato, sans-serif',
          fontSize: '1rem', // Auto-scales: ~11.9px → 14px
          fontWeight: 400,
          lineHeight: 1.5,
        },
      },
      cta: {
        fontFamily: 'Lato, sans-serif',
        fontSize: '1.286rem', // Auto-scales: ~15.3px → 18px
        fontWeight: 600,
        lineHeight: 1.5,
        textTransform: 'uppercase',
      },
      label: {
        fontFamily: 'Lato, sans-serif',
        fontSize: '1.143rem', // Auto-scales: ~13.6px → 16px
        fontWeight: 500,
        lineHeight: 1.5,
      },
      express: {
        fontFamily: 'Lato, sans-serif',
        fontSize: '1.143rem', // Auto-scales: ~13.6px → 16px
        fontWeight: 600,
        lineHeight: 1.5,
      },
    },
  },
};
